import { render, staticRenderFns } from "./TwoColumns.vue?vue&type=template&id=b5901bc8"
var script = {}
import style0 from "./TwoColumns.vue?vue&type=style&index=0&id=b5901bc8&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports